import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { PoItemsDetails } from "./po-items-details";

export class GetItemsForSaleOrderVendor extends GlobalResponseObject{
    data?: PoItemsDetails[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoItemsDetails[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}